/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var UsersAltIcon = createIcon({
  name: 'UsersAltIcon',
  height: 1024,
  width: 951,
  svgPath: 'M804.571 511.122c0-80.896-65.536-146.432-146.432-146.432s-146.432 65.536-146.432 146.432c0 80.896 65.536 146.432 146.432 146.432s146.432-65.536 146.432-146.432zM475.429 255.268v0c0 0 43.447 36.571 109.714 36.279l146.286 0.293c66.267 0 109.714-36.571 109.714-36.571s109.714-73.143 109.714-327.607h-585.143c0 0 0 244.517 109.714 327.607zM438.857 730.551c0-80.896-65.536-146.432-146.432-146.432s-146.432 65.536-146.432 146.432c0 80.896 65.536 146.432 146.432 146.432s146.432-65.536 146.432-146.432zM477.696 365.714c-160.768-27.429-189.733-218.697-189.733-218.697h-288.037c0 0 0 244.59 109.714 327.607v0c0 0 43.447 36.571 109.714 36.279l146.286 0.293c29.477 0 17.92 3.73 36.571-4.315 0 0-2.267-111.47 75.41-141.166v0z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
});
export default UsersAltIcon;